import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormGroup,
  Grid,
  makeStyles,
  Typography,
  CircularProgress,
  FormControl,
  TextField,
} from "@material-ui/core";

import { useFormik } from "formik";
import * as Yup from "yup";

import { observer } from "mobx-react-lite";

const validationSchema = Yup.object().shape({
  roomCode: Yup.string()
    .trim()
    .min(4, "Minimum 4 symbols")
    .max(10, "Maximum 10 symbols")
    .matches(/^[a-zA-Z0-9_.-]*$/, "Invalid symbols!")
    .required("Room code is required!"),
});

const useStyles = makeStyles((theme) => ({
  error: {
    color: "red",
    marginTop: ".85rem",
    textAlign: "center",
    maxWidth: 158,
  },
}));

const UpdateRoomCode = ({ roomCode, updateRoomCode }) => {
  const [updatingError, setUpdatingError] = useState("");

  const classes = useStyles();

  const formik = useFormik({
    initialValues: { roomCode },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      if (values.roomCode === formik.initialValues.roomCode) return;

      try {
        await updateRoomCode(values.roomCode);
      } catch (err) {
        setUpdatingError(
          err.response?.data?.message || "Saving failed, please try again!"
        );
      }
    },
  });

  useEffect(() => {
    setUpdatingError("");
  }, [formik.values]);

  return (
    <Box display="flex" alignItems="center" flexDirection="column" p={2.5}>
      <h3>
        Room Code
      </h3>
      <Box p={2} marginTop={2}>
        <FormGroup row>
          <Grid container direction={"column"} spacing={3}>
            <Box display="flex" alignItems="center">
              <FormControl className={classes.formControl}>
                <TextField
                  size="small"
                  label="Room Code  "
                  name="roomCode"
                  margin="dense"
                  inputProps={{ min: 1 }}
                  value={formik.values.roomCode}
                  onChange={(e) => {
                    e.target.value = e.target.value.toUpperCase();
                    formik.handleChange(e);
                  }}
                  onBlur={formik.handleBlur}
                  error={!!formik.touched.roomCode && !!formik.errors.roomCode}
                  helperText={formik.touched.roomCode && formik.errors.roomCode}
                />
              </FormControl>
            </Box>
          </Grid>
        </FormGroup>

        {updatingError && (
          <Typography className={classes.error} variant="body1">
            {updatingError}
          </Typography>
        )}
      </Box>

      <Box display="flex" justifyContent="center" m={2.5}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={formik.handleSubmit}
          disabled={
            !!formik.errors.roomCode ||
            formik.isSubmitting ||
            JSON.stringify(formik.values) ===
              JSON.stringify(formik.initialValues)
          }
        >
          {formik.isSubmitting ? (
            <>
              Please wait <CircularProgress color="inherit" size={16} />
            </>
          ) : (
            <> Update</>
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default observer(UpdateRoomCode);
